import type { Portfolio } from '../../api/portfolio-client/portfolio-client.type';
import { formatToISODate } from '../../helpers/date-time-helpers';
import { FloraSupportedObjectTypes, type FloraContextObject, type FloraContextualInfo } from '../flora/flora.type';
import { GeneralViewNames } from '../side-bar/side-bar.type';

/**
 * Get the financials flora context
 * @param {Portfolio} portfolio - The portfolio
 * @param {Date | string} startDate - The start date
 * @param {Date | string} endDate - The end date
 * @param {string | null} team - The team
 * @param {string | null} board - The board
 * @returns {FloraContextualInfo} The financials flora context
 */
function getFinancialFloraContext(
  portfolio: Portfolio,
  startDate: Date,
  endDate: Date,
  team: string | null,
  board: string | null,
  selectedMeasures?: string[],
): FloraContextualInfo {
  const currentObjects: FloraContextObject[] = [];

  if (team && board && board !== 'aggregate') {
    const teamObject = portfolio.projects.find((t) => t.id === team);
    const boardObject = teamObject?.subprojects?.find((b) => b.id === board);
    currentObjects.push({
      type: FloraSupportedObjectTypes.Subproject,
      id: board,
      name: boardObject?.name || '',
    });
  } else if (team && team !== 'aggregate') {
    const teamObject = portfolio.projects.find((t) => t.id === team);
    currentObjects.push({
      type: FloraSupportedObjectTypes.Project,
      id: team,
      name: teamObject?.name || '',
    });
  } else {
    currentObjects.push({
      type: FloraSupportedObjectTypes.Portfolio,
      id: portfolio.id,
      name: portfolio.name,
    });
  }

  return {
    currentModule: GeneralViewNames.Financials,
    currentObjects: currentObjects,
    startDate: formatToISODate(startDate),
    endDate: formatToISODate(endDate),
    selectedMeasures: selectedMeasures && selectedMeasures.length > 0 ? selectedMeasures : undefined,
  };
}

export { getFinancialFloraContext };
